import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { EntryRequestState } from '@api/models/enums/EntryRequestState';
import { GridFilterSelectMultiple } from './GridFilterSelectMultiple';

const options = Object.values(EntryRequestState);

interface Props {
  value?: EntryRequestState[];
  onChange: (value?: EntryRequestState) => void;
}

export const GridFilterApprovalState: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <GridFilterSelectMultiple
      value={value}
      options={options}
      onChange={onChange}
      getOptionId={(option: EntryRequestState) => option}
      getOptionName={(option: EntryRequestState) =>
        t(`invitation.entryRequest.state.${option}`)
      }
    />
  );
};
